import React, {useEffect, useState} from 'react';
import {toast} from '../../constants';
import useInterval from '../../hooks/useInterval';

interface Props {
    children?: React.ReactNode;
    className?: string;
    dismissToastItem: (id: number) => void;
    id: number;
    style: Record<string, any>;
}

const AutoDismissWrapper = ({children, className, dismissToastItem, id, style}: Props) => {
    const [milliseconds, setMilliseconds] = useState<number>(0);
    const [willAutoDismiss, setWillAutoDismiss] = useState<boolean>(true);

    const intervalCallback = () => setMilliseconds(milliseconds + 1);
    useInterval(intervalCallback, willAutoDismiss, 1);

    useEffect(() => {
        const shouldDismiss: boolean = willAutoDismiss && milliseconds >= toast.DISMISS_TIME;
        if (!shouldDismiss) return;
        setWillAutoDismiss(false);
        dismissToastItem(id);
    }, [milliseconds, willAutoDismiss]);

    return (
        <div
            className={className}
            // The data-id is relevant to the animation on the parent component
            data-id={id}
            onBlur={() => setWillAutoDismiss(true)}
            onFocus={() => setWillAutoDismiss(false)}
            onMouseOut={() => setWillAutoDismiss(true)}
            onMouseOver={() => setWillAutoDismiss(false)}
            style={style}>
            {children}
        </div>
    );
};

export default AutoDismissWrapper;
